import React from 'react';
import Button from './Button';

const PrimaryCTA = ({ children, onClick, className = '', ...props }) => {
    return (
        <Button
            variant="primary" // We override the bg with style
            className={`text-white border-0 font-semibold rounded-[30px] px-[32px] py-[16px] text-[16px] sm:text-[18px] transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 ${className}`}
            style={{ background: 'var(--gradient-accent)' }}
            onClick={onClick}
            {...props}
        >
            {children}
        </Button>
    );
};

export default PrimaryCTA;
